<app-subdomain-summary
    [domain]="domain"
    [subdomain]="rubricComponent"
    [isActive]="rubricComponent?.Value === currentRubricComponent"
    [readonly]="true"
    [showFocusAreas]="showFocusAreas"
    [isFocusArea]="isFocusArea"
    (onClick)="onClick()">
    <edl-proficiency-pill 
        class="p-2" 
        [teacherRatingValue]="teacherRubricResponse" 
        [evaluatorRatingValue]="evaluatorRubricResponse" 
        [resourceFile]="resourceFile" 
        [resourceFileKey]="resourceFileKey">
    </edl-proficiency-pill>
</app-subdomain-summary>
